// ------------------------------------
// Constants
// ------------------------------------
// prettier-ignore
export const NETWORK_TUNNELS_PUT_REQUEST = 'NETWORK_TUNNELS_PUT_REQUEST';
// prettier-ignore
export const NETWORK_TUNNELS_PUT_REQUEST_SUCCESS = 'NETWORK_TUNNELS_PUT_REQUEST_SUCCESS';
// prettier-ignore
export const NETWORK_TUNNELS_PUT_REQUEST_FAILURE = 'NETWORK_TUNNELS_PUT_REQUEST_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------
export function request(payload, resolve, reject) {
  return {
    type: NETWORK_TUNNELS_PUT_REQUEST,
    payload,
    resolve,
    reject,
  };
}

export function requestSuccess(data, payload) {
  return {
    type: NETWORK_TUNNELS_PUT_REQUEST_SUCCESS,
    data,
    payload,
  };
}

export function requestFailure(error, payload) {
  return {
    type: NETWORK_TUNNELS_PUT_REQUEST_FAILURE,
    error,
    payload,
  };
}
